import { render } from "./CardQuotation.vue?vue&type=template&id=438715f3&scoped=true"
import script from "./CardQuotation.vue?vue&type=script&lang=js"
export * from "./CardQuotation.vue?vue&type=script&lang=js"

import "./CardQuotation.vue?vue&type=style&index=0&id=438715f3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438715f3"]])

export default __exports__